// Axios singleton — base URL from env, JSON content-type, auth interceptor.
// Used by every API module under src/api.

import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// Request — attach bearer token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('lc.token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response — surface a normalized error shape
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      localStorage.removeItem('lc.token');
      // Soft redirect — bypass routing concerns
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
